export default __webpack_public_path__ + "static/media/water-drop.0af2dda6.png";